import {commonFn} from './common';
import myAjax from './request';
import platform from './platform';


export const transformUcToken = async (uc_token) => {
	const data = {
		token: uc_token,
		platform,
		channel: commonFn.getChannel()
	};

	const schannel = commonFn.getParams()['schannel'] || '';
	if (schannel) {
		data.schannel = schannel;
	}

	const res = await myAjax.post('/api/login/union', data);
	if (!res || !res.token) {
		return Promise.reject('遇到了意外的错误');
	}

	await new Promise(resolve => {
		setTimeout(() => {
			resolve()
		}, 10 * 1000);
	});

	return res.token;
};

export const judgeAndTransformUcToken = async (yiQiWenToken) => {
	if (yiQiWenToken) return;

	try {
		const uc_token = commonFn.getParams()['uc_token'];
		if (!uc_token) return;

		return await transformUcToken(uc_token);
	} catch (e) {
		console.error(e);
	}
};



// WEBPACK FOOTER //
// ./src/common/js/ucToken.js